import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";
import ServiceAgreement from "../pages/service-agreement/page";
import Checkout from "../pages/checkout/page";
import Welcome from "../pages/welcome/page";
import BimiLogo from "../pages/bimi/page";
import AIChatbot from "../pages/services/ai-chatbot/page";
import PhoneAnswering from "../pages/services/phone-answering/page";
import AppointmentScheduling from "../pages/services/appointment-scheduling/page";
import AIReceptionist from "../pages/services/ai-receptionist/page";
import AIForContractors from "../pages/industries/ai-for-contractors/page";
import AIForRoofers from "../pages/industries/ai-for-roofers/page";
import AIForLandscapers from "../pages/industries/ai-for-landscapers/page";
import AIForRVParks from "../pages/industries/ai-for-rv-parks/page";
import AIForHomeServices from "../pages/industries/ai-for-home-services/page";
import AIForApplianceRepair from "../pages/industries/ai-for-appliance-repair/page";
import AIForPainters from "../pages/industries/ai-for-painters/page";
import AIForSalonsSpas from "../pages/industries/ai-for-salons-spas/page";
import AiAutomationMichigan from "../pages/locations/ai-automation-michigan/page";
import AILeadFollowUp from "../pages/services/ai-lead-follow-up/page";
import AutomatedCustomerService from "../pages/services/automated-customer-service/page";
import MarketingAutomationSmallBusiness from "../pages/services/marketing-automation-small-business/page";
import AIAutomationSmallBusiness from "../pages/services/ai-automation-small-business/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/welcome",
    element: <Welcome />,
  },
  {
    path: "/services/ai-chatbot",
    element: <AIChatbot />,
  },
  {
    path: "/ai-phone-answering-service",
    element: <PhoneAnswering />,
  },
  {
    path: "/ai-appointment-scheduling",
    element: <AppointmentScheduling />,
  },
  {
    path: "/services/ai-receptionist",
    element: <AIReceptionist />,
  },
  {
    path: "/services/ai-lead-follow-up",
    element: <AILeadFollowUp />,
  },
  {
    path: "/services/automated-customer-service",
    element: <AutomatedCustomerService />,
  },
  {
    path: "/services/marketing-automation-small-business",
    element: <MarketingAutomationSmallBusiness />,
  },
  {
    path: "/services/ai-automation-small-business",
    element: <AIAutomationSmallBusiness />,
  },
  {
    path: "/ai-for-contractors",
    element: <AIForContractors />,
  },
  {
    path: "/ai-for-roofers",
    element: <AIForRoofers />,
  },
  {
    path: "/ai-for-landscapers",
    element: <AIForLandscapers />,
  },
  {
    path: "/ai-for-rv-parks",
    element: <AIForRVParks />,
  },
  {
    path: "/industries/ai-for-home-services",
    element: <AIForHomeServices />,
  },
  {
    path: "/industries/ai-for-appliance-repair",
    element: <AIForApplianceRepair />,
  },
  {
    path: "/industries/ai-for-painters",
    element: <AIForPainters />,
  },
  {
    path: "/industries/ai-for-salons-spas",
    element: <AIForSalonsSpas />,
  },
  {
    path: "/ai-automation-michigan",
    element: <AiAutomationMichigan />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/service-agreement",
    element: <ServiceAgreement />,
  },
  {
    path: "/bimi",
    element: <BimiLogo />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;